import React from 'react';

export default function LoadingSpinner() {

  return (
    <span className="loadingSpinner">
    </span>
  );
};
